import { CoreModal, CoreModalDescription, coreToast } from "@verity/components/core";
import i18n from "../../../../../i18n";

type DeleteConfirmationModalProps = {
	onClose: () => void;
	onDelete: () => Promise<void>;
};

export default function DeleteConfirmationModal({ onClose, onDelete }: DeleteConfirmationModalProps) {
	return (
		<CoreModal
			open
			onClose={onClose}
			title={i18n.t("result.components.resultsPage.deleteModal.title")}
			buttons={[
				{
					text: i18n.t("result.components.resultsPage.deleteModal.cancel"),
					color: "secondary",
					onClick: onClose,
				},
				{
					text: i18n.t("portal.components.assessmentPage.createStandAloneQuizDialog.inviteeInfoTableTSX.delete"),
					color: "cancel",
					onClick: async () => {
						try {
							await onDelete();

							coreToast.success(i18n.t("result.components.resultsPage.deleteModal.success"));
						} catch (e) {
							coreToast.error(i18n.t("result.components.resultsPage.deleteModal.error"));
						} finally {
							onClose();
						}
					},
				},
			]}
			modalVerticalPosition={"top"}
			modalMargin={"25px 0px 0px 0px"}
			keepTopBorderRadius={true}
		>
			<CoreModalDescription>{i18n.t("result.components.resultsPage.deleteModal.description")}</CoreModalDescription>
		</CoreModal>
	);
}
